import useAuth from '../features/authentication/hooks/useAuth';

const useIsToolkitPlan = () => {
  const { user } = useAuth();
  return user ? ['BASIC', 'BASIC_PLUS', 'BASIC_NL'].includes(user.plan) : false;
};

export default useIsToolkitPlan;
